<div class="row" *ngIf="modelList.length > 0;else noDocument">
    
    <div class="col-md-6 col-sm-12 p-2" *ngFor="let header of modelList;">
        <div class="card rapporti-card p-0" style="min-height: 550px;">
            <div class="header-zona">
                <span class="titolo-card-doc"
                    *ngIf="header.idCategoria!=6">{{getDescrizioneById(header.idCategoria)}}</span>
            </div>
            <div class="card-body rapporti-doc" style="min-height: 50px;">
                <ul>
                    <li *ngFor="let element of header.elements;" class="mb-1">
                        <a href="javascript:void(0)" (click)="openPdfDocument(websiteUrl + element.url)" class="colored">{{element.descrizione}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

<ng-template #noDocument>
    <div class="row">
        <div class="w-100 col-12 p-2">
          <div class="card rapporti-card p-0">
            <div class="header-zona">
              <span class="titolo-card-doc">Rapporti di evento</span>
            </div>
            <div class="card-body rapporti-doc">
              <div class="col-xxxl-12 col-md-12" >Nessun contenuto recuperato per questa sezione
              </div>
            </div>
          </div>
        </div>
      </div>
</ng-template>